import {Injectable} from '@angular/core';
import {BaseService} from '../shared/base-service/base-service.service';
import {Observable} from 'rxjs';
import {UrlConstant} from '../shared/constants/url.class';
import {Group} from '../model/group.class';

@Injectable()
export class OrderService extends BaseService {
  serviceUrl: string = UrlConstant.URL_ORDER;

  getOrders(payload: any): Observable<any> {
    return this.post(this.serviceUrl + '/GetOrders', payload);
  }

  deleteOrder(id: number): Observable<number> {
    return this.delete(this.serviceUrl + '/' + id, null);
  }

  addOrder(order: any): Observable<any> {
    return this.post(this.serviceUrl, order);
  }

  updateOrder(order: any): Observable<any> {
    return this.put(this.serviceUrl + '/' + order.id, order);
  }

  getOrderById(id: number): Observable<any> {
    return this.get(this.serviceUrl + '/' + id);
  }

  getResultValueDoubleTestFilter(payload): any {
    return this.post(
      this.serviceUrl + '/GetResultValueDoubleTestFilter',
      payload
    );
  }
  getResultValueNeonatalScreening(payload): any {
    return this.post(
      this.serviceUrl + '/GetResultValueNeonatalScreening',
      payload
    );
  }
  saveDoubleTestResult(payload): any {
    return this.post(this.serviceUrl + '/SaveDoubleTestResult', payload);
  }

  getOrderById4Print(id: number): Observable<any> {
    return this.get(this.serviceUrl + '/print/' + id);
  }

  uploadFile(url: string, FormData: any): Observable<any> {
    return this.post(url, FormData);
  }

  postFormData(url: string, FormData: any): Observable<any> {
    return this.post(url, FormData);
  }

  putFormData(url: string, FormData: any): Observable<any> {
    return this.put(url, FormData);
  }

  getCountries(): Observable<any[]> {
    return this.get(UrlConstant.URL_COUNTRY + '/display');
  }

  getDestCountries(): Observable<any[]> {
    return this.get(UrlConstant.URL_COUNTRY + '/destination');
  }

  getDestCitiesByCountry(countryId: any): Observable<any[]> {
    return this.get(
      UrlConstant.URL_DEST_CITY + '?countryId=' + countryId + '&pageSize=500'
    );
  }

  getDiscountProgramUsers(programId: any): Observable<any[]> {
    return this.get(UrlConstant.URL_DISCOUNT_PROGRAM + '/users/' + programId);
  }

  getIndividualDiscountUsers(discountId: any): Observable<any[]> {
    return this.get(
      UrlConstant.URL_INDIVIDUAL_DISCOUNT + '/users/' + discountId
    );
  }

  getProvincesDisplay(): Observable<any[]> {
    return this.get(UrlConstant.URL_PROVINCE + '/display');
  }

  getDistrictsDisplay(provinceId: any): Observable<any[]> {
    return this.get(UrlConstant.URL_PROVINCE + '/cities/display/' + provinceId);
  }

  getCommunesDisplay(districtId: any): Observable<any[]> {
    return this.get(UrlConstant.URL_PROVINCE + '/wards/display/' + districtId);
  }

  getProvinceById(id: number): Observable<any> {
    return this.get(UrlConstant.URL_PROVINCE + '/' + id);
  }

  getDistrictById(id: number): Observable<any> {
    return this.get(UrlConstant.URL_PROVINCE + '/city/' + id);
  }

  getHscodesDisplay(searchName: any): Observable<any[]> {
    return this.get(UrlConstant.URL_HSCODE + '/display?nameVi=' + searchName);
  }

  // payment
  getPaymentUrl(id: number): Observable<any> {
    return this.get(UrlConstant.URL_PAYMENT + '/GetURL/' + id);
  }

  sendPaymentResponse(paymentParams: string): Observable<any> {
    return this.get(
      UrlConstant.URL_PAYMENT + '/PaymentResponse' + paymentParams
    );
  }

  // order cancel
  cancelOrder(cancelObj: any): Observable<any> {
    return this.post(
      this.serviceUrl + '/cancel/' + cancelObj.orderId,
      cancelObj
    );
  }

  // order note
  addOrderNote(noteObj: any): Observable<any> {
    return this.post(this.serviceUrl + '/note/' + noteObj.orderId, noteObj);
  }

  getOrderResultValues(orderId: any): Observable<any> {
    return this.get(this.serviceUrl + '/GetResultValues/' + orderId);
  }

  getOrderResultValueByOrdCode(orderId: string): Observable<any> {
    return this.get(this.serviceUrl + `/GetResultValueByOrderCode/${orderId}`);
  }

  assignOrder(payload: any): Observable<any> {
    return this.post('/Orders/AssignOrder', payload);
  }

  sendSms(payload: any): Observable<any> {
    return this.post('/Sms/Send2', payload);
  }

  sendEmail(payload: any): Observable<any> {
    return this.post('/Email/Send', payload);
  }

  getOrderForPrintResult(payload: any): any {
    return this.post(this.serviceUrl + '/GetOrderForPrintResult', payload);
  }

  validResult(payload: any): Observable<any> {
    return this.post(`/Orders/ValidResult`, payload);
  }

  unValidResult(payload: any): Observable<any> {
    return this.post(`/Orders/UnValidResult`, payload);
  }

  validResultByGroup(payload: any): Observable<any> {
    return this.post(`/Orders/ValidResultByGroup`, payload);
  }

  exportOrderData(payload: any): any {
    return this.post(`/Orders/ExportOrderData`, payload);
  }
  getOrderDataStatistics(payload: any): any {
    return this.post('/Orders/ExportOrderDataStatistics', payload);
  }
  getOutsourceOrderDetails(payload: any): Observable<any> {
    return this.post('/Orders/OrderOutSourceData', payload);
  }

  // Tích/bỏ tích trạng thái đã thanh toán cho XN gửi ngoài
  updateOutSourcePaid(payload: any): Observable<any> {
    return this.post('/Orders/UpdateOutSourcePaid', payload);
  }

  markExcessEntry(payload: any): Observable<any> {
    return this.post('/Orders/MarkExcessEntry', payload);
  }

  setFullResult(payload: any): Observable<any> {
    return this.post(`/Orders/SetFullResult`, payload);
  }

  unSetFullResult(payload: any): Observable<any> {
    return this.post(`/Orders/UnSetFullResult`, payload);
  }

  getOrderReport(payload: any): Observable<any> {
    return this.post('/Report/GetOrderReport', payload);
  }
  getSmsLogFilter(payload: any): Observable<any> {
    return this.post('/SmsLog/SmsLogFilter', payload);
  }
  getZaloLogFilter(payload: any): Observable<any> {
    return this.post('/ZaloLog/ZaloLogFilter', payload);
  }
  getBilling(payload: any): Observable<any> {
    return this.post('/Billing/GetBillings', payload);
  }

  confirmBilling(payload: any): Observable<any> {
    return this.post('/Billing/ConfirmBilling', payload);
  }

  deleteBilling(payload: any): Observable<any> {
    return this.post('/Billing/DeleteBilling', payload);
  }

  exportOrderWithResult(payload: any): any {
    return this.post('/Orders/ReportExcelResult', payload, null, 'blob');
  }

  getShareLabs(payload: any): Observable<any> {
    return this.post('/Orders/GetSharedLabs', payload);
  }

  setShareLabs(payload: any): Observable<any> {
    return this.post('/Orders/SetSharedLab', payload);
  }

  exportOrderPcr(payload: any): Observable<any> {
    return this.post('/Orders/ExportOrderPcrData', payload);
  }

  setPcrNumber(payload: any): Observable<any> {
    return this.post('/Orders/SetPcrNumberNumber', payload);
  }

  readPcrResultTxt(payload: any): Observable<any> {
    return this.post('/Orders/ReadPcrResultTxt', payload);
  }

  editSetLabTime(payload: any): Observable<any> {
    return this.post('/Orders/EditSetLabTime', payload);
  }

  validLevel1(payload: any): Observable<any> {
    return this.post(`/Orders/Valid1`, payload);
  }

  unvalidLevel1(payload: any): Observable<any> {
    return this.post(`/Orders/UnValid1`, payload);
  }
  //new

  savelogSendResultManual(payload: any): any {
    return this.post('/Orders/SavelogSendResultManual', payload);
  }
}
